import * as React from 'react';
import {RouteComponentProps} from 'react-router';
import {Button} from 'antd';
import {Link} from 'react-router-dom';

import JungClient from '../../api/JungClient';
import Header from "../../components/Header/Header";

export interface State{
  description: string,
  profile: string
}

import styles from './JungProfilePage.module.scss';
class JungProfilePage extends React.Component<{} & RouteComponentProps<any>, State>{

  public state = {
    description: '',
    profile: this.props.match.params.profile
  };

  public render(){
    return (
      <div className={styles.jungProfilePage}>
        <Header page={'Perfil Jung'} reloadable={false}/>
        <h3>{this.state.profile.toUpperCase()}</h3>
        <div dangerouslySetInnerHTML={{__html: this.state.description}}/>
        <Link to={'/'}>
          <Button type="primary" icon="left" >Voltar</Button>
        </Link>
      </div>
    )
  }

  public async componentDidMount(){
    const response = await JungClient().getProfile(this.props.match.params.profile);

    this.setState({
      description: response.descricao
    });

  }
}

export default JungProfilePage;
